import React from "react";

function normalize(item){

if(!item){

return{

text:"Positioning item",
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

if(typeof item==="string"){

return{

text:item,
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

return{

text:item.text || "Positioning item",
priority:item.priority || "MEDIUM",
effort:item.effort || "MEDIUM",
impact:item.impact || "MEDIUM"

};

}

function priorityColor(priority){

if(priority==="HIGH")
return "bg-red-100 text-red-700";

if(priority==="MEDIUM")
return "bg-amber-100 text-amber-700";

return "bg-green-100 text-green-700";

}

export default function PositioningCard({data}){

const positioning = (data?.positioning || [])
.filter(Boolean)
.map(normalize);

if(positioning.length===0){

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Market Positioning
</h3>

<p className="text-sm text-slate-500 mt-3">
Positioning not generated.
</p>

</div>

);

}

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">
Positioning Strategy
</h3>

<p className="text-sm text-slate-600 mt-1">
AI recommended positioning direction.
</p>

<div className="space-y-3 mt-4">

{positioning.map((item,i)=>(

<div
key={i}
className="border bg-slate-50 rounded-lg p-3"
>

<p className="text-sm text-slate-700">
{item.text}
</p>

<div className="flex gap-2 mt-2 text-xs flex-wrap">

<span className={`px-2 py-1 rounded ${priorityColor(item.priority)}`}>
Priority {item.priority}
</span>

<span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">
Effort {item.effort}
</span>

<span className="bg-green-100 text-green-700 px-2 py-1 rounded">
Impact {item.impact}
</span>

</div>

</div>

))}

</div>

</div>

);

}